import { MeasurementUnits, Qualifier } from "fe-common/graphql";
import { useMemo } from "react";
import { Relations } from "shared";

export function useGetDuration(
  selectedQualifiers: Qualifier[],
): [number, MeasurementUnits] {
  return useMemo(() => {
    const durationRelation = selectedQualifiers.find(
      (q) => q.relation.id === Relations.DURATION,
    );
    return [durationRelation?.range?.low, durationRelation?.range?.units];
  }, [selectedQualifiers]);
}
